import config from "../../config"
import Image from "react-bootstrap/Image"
import { filterSubscriptionAndShippingFee, getImageSize } from "../common/utils"
import React from "react"
import _ from "underscore"
import { checkHsCountryTags } from "../PDP/helpers"

export const defaultCartAttributes = [
  {
    key: 'tradeTaxAdjustment',
    value: '0',
  },
  {
    key: 'apiHost',
    value: config.host_rebag_api
  },
  {
    key: 'tradesApplied',
    value: '0',
  },
  {
    key: 'pointsApplied',
    value: '0',
  }
]

export const filterLineItems = (lineItems) => {
  return lineItems ? filterSubscriptionAndShippingFee(lineItems) : [];
}

export const isCartLineItemSubscription = (lineItem) => {
  let isThisLineItemSubscription = false;
  config.subscriptions.monthly.forEach(item => {
    if (item.merchandiseId === lineItem.merchandise.id) {
      isThisLineItemSubscription = true;
    }
  })
  config.subscriptions.yearly.forEach(item => {
    if (item.merchandiseId === lineItem.merchandise.id) {
      isThisLineItemSubscription = true;
    }
  })
  if (config.subscriptions.zeroCostItem.variantId === lineItem.merchandise.id) {
    isThisLineItemSubscription = true;
  }
  return isThisLineItemSubscription
}

export const cartHasShippingProtection = (cartLines) => {
  let hasShippingProtection = false;
  cartLines.forEach((lineItem) => {
    if (isCartLineItemShippingFee(lineItem)) {
      hasShippingProtection = true;
    }
  })
  return hasShippingProtection
}

export const isCartLineItemShippingFee = (lineItem) => {
  return lineItem.merchandise.sku && lineItem.merchandise.sku.includes('shipping-protection-');
}

export const getCartLineItemShippingFee = (cartLines) => {
  return cartLines.find(cartLine => {
    return isCartLineItemShippingFee(cartLine);
  })
}

export const buildProductImage = (product) => {
  return (
    <div className={`cart-row__product-image-container`}>
      {!product.availableForSale &&
        <div className="pdp__sold-out-label pdp__sold-out-label--cart">Sold</div>
      }
      <Image
        src={product.featuredImage && product.featuredImage.url ? getImageSize(product.featuredImage.url) : config.PLACE_HOLDER}
        className="cart-row__product-image"
        alt={product.title}
        fluid
      />
    </div>
  )
}

export const getSoldOutItems = (lineItems) => {
  return filterSubscriptionAndShippingFee(lineItems).filter((lineItem) => {
    return lineItem.merchandise.product.availableForSale === false || lineItem.merchandise.quantityAvailable === 0;
  });
}

export const isLineItemUsOnly = (lineItem, exotic_materials_list) => {
  const { noHsCodeTag, noCountryOfOriginTag} = checkHsCountryTags(lineItem.merchandise.product.tags);
  const is_exotic = checkIfExotic(lineItem.merchandise.product.product_details, exotic_materials_list);

  if (is_exotic || noHsCodeTag || noCountryOfOriginTag) {
    return true
  } else {
    return false
  }
}

export const computeTotalAppliedGC = (cart, temporary_shipping_rate, walletGiftCardCodes, rewardsGiftCardCodes) => {
  let rebagCredit = 0;
  let walletCash = 0;
  let rewardsCredit = 0;

  if (cart) {
    const { appliedGiftCards } = cart;
    const totalTax = 0;
    if (!_.isEmpty(appliedGiftCards)) {
      appliedGiftCards.forEach((appliedGiftCard) => {
        if (walletGiftCardCodes.some(giftCard => giftCard.slice(-4) === appliedGiftCard.lastCharacters)) {
          walletCash += parseFloat(appliedGiftCard.amountUsed.amount);
        } else if (rewardsGiftCardCodes.some(giftCard => giftCard.slice(-4) === appliedGiftCard.lastCharacters)) {
          rewardsCredit += parseFloat(appliedGiftCard.amountUsed.amount);
        } else {
          rebagCredit += parseFloat(appliedGiftCard.amountUsed.amount);
        }
      });

      if (totalTax - rebagCredit - rewardsCredit - walletCash >= 0) {
        return { rebagCredit, walletCash, rewardsCredit };
      } else {
        if (totalTax) {
          if (rebagCredit >= totalTax) {
            //we deduct all tax from rebagCredit
            rebagCredit -= totalTax;
          } else if (rebagCredit) {
            //we deduct tax from rebagCredit, then rewardsCredit and then wallet cash
            let remainderTaxAmount = totalTax;
            remainderTaxAmount -= rebagCredit;
            rebagCredit = 0;
            if (rewardsCredit > remainderTaxAmount) {
              rewardsCredit -= remainderTaxAmount;
            } else {
              remainderTaxAmount -= rewardsCredit;
              rewardsCredit = 0;
              walletCash -= remainderTaxAmount;
            }

          } else if (rewardsCredit >= totalTax) {
            //we deduct all tax from rewardsCredit
            rewardsCredit -= totalTax;
          } else if (rewardsCredit) {
            //we deduct tax from rewardsCredit and then wallet cash
            let remainderTaxAmount = totalTax;
            remainderTaxAmount -= rewardsCredit;
            rewardsCredit = 0;
            walletCash -= remainderTaxAmount;
          } else {
            walletCash -= totalTax;
          }
        }

        // if (shippingLine && shippingLine.priceV2) {
        //     if (rebagCredit >= shippingLine.priceV2.amount) {
        //         //we deduct all shipping tax from rebagCredit
        //         rebagCredit -= shippingLine.priceV2.amount;
        //     } else if (rebagCredit) {
        //         //we deduct shipping tax from rebagCredit, then rewardsCredit and then wallet cash
        //         let remainderShippingAmount = shippingLine.priceV2.amount;
        //         remainderShippingAmount -= rebagCredit;
        //         rebagCredit = 0;
        //         if (rewardsCredit > remainderShippingAmount) {
        //             rewardsCredit -= remainderShippingAmount;
        //         } else {
        //             remainderShippingAmount -= rewardsCredit;
        //             rewardsCredit = 0;
        //             walletCash -= remainderShippingAmount;
        //         }
        //     } else if (rewardsCredit >= shippingLine.priceV2.amount) {
        //         //we deduct all shipping taxes from rewardsCredit
        //         rewardsCredit -= shippingLine.priceV2.amount;
        //     } else if (rewardsCredit) {
        //         //we deduct shipping taxes from rewardsCredit and then wallet cash
        //         let remainderTaxAmount = shippingLine.priceV2.amount;
        //         remainderTaxAmount -= rewardsCredit;
        //         rewardsCredit = 0;
        //         walletCash -= remainderTaxAmount;
        //     } else {
        //         walletCash -= shippingLine.priceV2.amount;
        //     }
        // }
      }
    }
  }
  return { rebagCredit, walletCash, rewardsCredit };
};

export const computeLineItemRewardsPlusDiscount = (lineItem) => {
  const price = parseFloat(lineItem.merchandise.price.amount);
  let threshold = null;
  for (let i = 0; i < config.subscription_discount_thresholds.length; i++ ) {
    if (price >= config.subscription_discount_thresholds[i].threshold) {
      threshold = config.subscription_discount_thresholds[i + 1];
    }
  }
  if(!threshold) threshold = config.subscription_discount_thresholds[0];
  if (threshold.discount_type === 'fixed') {
    lineItem.discountedPrice = price - threshold.discount_amount;
    return lineItem;
  } else {
    lineItem.discountedPrice = price - (price * threshold.discount_amount) / 100;
    return lineItem;
  }
}

export const checkIfExotic = (metafields, exotic_materials_list) => {
  let isExotic = false;
  metafields &&
  metafields.forEach((metafield) => {
    if (["exterior_material", "interior_material"].includes(metafield.key)) {
      exotic_materials_list.forEach((exotic_material) => {
        if (metafield.value.includes(exotic_material)) {
          isExotic = true;
        }
      });
    }
  });
  return isExotic;
};

export const mapCartLinesStandardPriceToJson = (cartLines) => {
  const mappedProducts = {};
  filterSubscriptionAndShippingFee(cartLines).forEach((cartLine) => {
    mappedProducts[cartLine.merchandise.id] = cartLine.merchandise.price.amount;
  });
  return JSON.stringify(mappedProducts);
}

export const addDelay = (seconds) => {
  return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}

export const getShippingItem = (subtotalAmount) => {
  return config.shippingProtectionFees.find(fee => fee.min <= subtotalAmount && fee.max >= subtotalAmount)
}
